export default function(css)
{
	const values =
	(
		css.match(/(--[^:;})]*:[^;})]*)/g) || []
	)
	.map
	(
		v =>
		{
			const parts = v.split(':').map(v=>v.trim());
			return [parts.shift(),parts.join(':')];
		}
	)
	.reduce
	(
		(result,part) =>
		{
			result[part[0].slice(2)] = part[1];
			return result;
		},
		{}
	);

	const cssPieces = css.replace(/([{};])/g,'\n$1\n').split('\n');
	let nestLevel = 0;
	const rules = [];
	let rule = [];
	cssPieces.forEach
	(
		piece =>
		{
			rule.push(piece);
			// noinspection FallThroughInSwitchStatementJS
			switch(piece)
			{
				case '{':
				{
					++nestLevel;
					break;
				}
				case '}':
				{
					--nestLevel;
				}
				case ';':
				{
					if (nestLevel === 0)
					{
						const ruleParts = [rule.join('')];
						const varsInThisRule = {};
						rule = [];
						try
						{
							let match;
							// noinspection JSAssignmentUsedAsCondition
							while (match = ruleParts.slice(-1)[0].match(/var\(--([^)]+)\)([\s\S]*)/))
							{
								varsInThisRule[match[1]] = true;
								ruleParts.push(ruleParts.pop().substr(0, match.index));
								ruleParts.push('--' + match[1], match[2]);
							}
						}
						catch (e)
						{
							// console.warn('Error while processing css rules', e);
						}

						rules.push
						(
							{
								cssVariables: Object.keys(varsInThisRule),
								ruleParts: ruleParts
							}
						);
					}
					break;
				}
			}
		}
	);

	return {rules,values};
}